/*! For license information please see index.js.LICENSE.txt */
(() => {
  'use strict';
  var t = {
      d: (e, r) => {
        for (var n in r) t.o(r, n) && !t.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: r[n] });
      },
      o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
      r: (t) => {
        'undefined' != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
          Object.defineProperty(t, '__esModule', { value: !0 });
      },
    },
    e = {};
  function r(t) {
    return (
      (r =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            }),
      r(t)
    );
  }
  function n() {
    n = function () {
      return e;
    };
    var t,
      e = {},
      o = Object.prototype,
      i = o.hasOwnProperty,
      a =
        Object.defineProperty ||
        function (t, e, r) {
          t[e] = r.value;
        },
      c = 'function' == typeof Symbol ? Symbol : {},
      u = c.iterator || '@@iterator',
      s = c.asyncIterator || '@@asyncIterator',
      l = c.toStringTag || '@@toStringTag';
    function f(t, e, r) {
      return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
    }
    try {
      f({}, '');
    } catch (t) {
      f = function (t, e, r) {
        return (t[e] = r);
      };
    }
    function h(t, e, r, n) {
      var o = e && e.prototype instanceof w ? e : w,
        i = Object.create(o.prototype),
        c = new A(n || []);
      return a(i, '_invoke', { value: T(t, r, c) }), i;
    }
    function p(t, e, r) {
      try {
        return { type: 'normal', arg: t.call(e, r) };
      } catch (t) {
        return { type: 'throw', arg: t };
      }
    }
    e.wrap = h;
    var y = 'suspendedStart',
      v = 'suspendedYield',
      d = 'executing',
      g = 'completed',
      m = {};
    function w() {}
    function b() {}
    function x() {}
    var E = {};
    f(E, u, function () {
      return this;
    });
    var L = Object.getPrototypeOf,
      O = L && L(L(I([])));
    O && O !== o && i.call(O, u) && (E = O);
    var S = (x.prototype = w.prototype = Object.create(E));
    function P(t) {
      ['next', 'throw', 'return'].forEach(function (e) {
        f(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function _(t, e) {
      function n(o, a, c, u) {
        var s = p(t[o], t, a);
        if ('throw' !== s.type) {
          var l = s.arg,
            f = l.value;
          return f && 'object' == r(f) && i.call(f, '__await')
            ? e.resolve(f.__await).then(
                function (t) {
                  n('next', t, c, u);
                },
                function (t) {
                  n('throw', t, c, u);
                },
              )
            : e.resolve(f).then(
                function (t) {
                  (l.value = t), c(l);
                },
                function (t) {
                  return n('throw', t, c, u);
                },
              );
        }
        u(s.arg);
      }
      var o;
      a(this, '_invoke', {
        value: function (t, r) {
          function i() {
            return new e(function (e, o) {
              n(t, r, e, o);
            });
          }
          return (o = o ? o.then(i, i) : i());
        },
      });
    }
    function T(e, r, n) {
      var o = y;
      return function (i, a) {
        if (o === d) throw new Error('Generator is already running');
        if (o === g) {
          if ('throw' === i) throw a;
          return { value: t, done: !0 };
        }
        for (n.method = i, n.arg = a; ; ) {
          var c = n.delegate;
          if (c) {
            var u = j(c, n);
            if (u) {
              if (u === m) continue;
              return u;
            }
          }
          if ('next' === n.method) n.sent = n._sent = n.arg;
          else if ('throw' === n.method) {
            if (o === y) throw ((o = g), n.arg);
            n.dispatchException(n.arg);
          } else 'return' === n.method && n.abrupt('return', n.arg);
          o = d;
          var s = p(e, r, n);
          if ('normal' === s.type) {
            if (((o = n.done ? g : v), s.arg === m)) continue;
            return { value: s.arg, done: n.done };
          }
          'throw' === s.type && ((o = g), (n.method = 'throw'), (n.arg = s.arg));
        }
      };
    }
    function j(e, r) {
      var n = r.method,
        o = e.iterator[n];
      if (o === t)
        return (
          (r.delegate = null),
          ('throw' === n && e.iterator.return && ((r.method = 'return'), (r.arg = t), j(e, r), 'throw' === r.method)) ||
            ('return' !== n &&
              ((r.method = 'throw'), (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
          m
        );
      var i = p(o, e.iterator, r.arg);
      if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), m;
      var a = i.arg;
      return a
        ? a.done
          ? ((r[e.resultName] = a.value),
            (r.next = e.nextLoc),
            'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
            (r.delegate = null),
            m)
          : a
        : ((r.method = 'throw'), (r.arg = new TypeError('iterator result is not an object')), (r.delegate = null), m);
    }
    function k(t) {
      var e = { tryLoc: t[0] };
      1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
    }
    function N(t) {
      var e = t.completion || {};
      (e.type = 'normal'), delete e.arg, (t.completion = e);
    }
    function A(t) {
      (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(k, this), this.reset(!0);
    }
    function I(e) {
      if (e || '' === e) {
        var n = e[u];
        if (n) return n.call(e);
        if ('function' == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            a = function r() {
              for (; ++o < e.length; ) if (i.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
              return (r.value = t), (r.done = !0), r;
            };
          return (a.next = a);
        }
      }
      throw new TypeError(r(e) + ' is not iterable');
    }
    return (
      (b.prototype = x),
      a(S, 'constructor', { value: x, configurable: !0 }),
      a(x, 'constructor', { value: b, configurable: !0 }),
      (b.displayName = f(x, l, 'GeneratorFunction')),
      (e.isGeneratorFunction = function (t) {
        var e = 'function' == typeof t && t.constructor;
        return !!e && (e === b || 'GeneratorFunction' === (e.displayName || e.name));
      }),
      (e.mark = function (t) {
        return (
          Object.setPrototypeOf ? Object.setPrototypeOf(t, x) : ((t.__proto__ = x), f(t, l, 'GeneratorFunction')),
          (t.prototype = Object.create(S)),
          t
        );
      }),
      (e.awrap = function (t) {
        return { __await: t };
      }),
      P(_.prototype),
      f(_.prototype, s, function () {
        return this;
      }),
      (e.AsyncIterator = _),
      (e.async = function (t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new _(h(t, r, n, o), i);
        return e.isGeneratorFunction(r)
          ? a
          : a.next().then(function (t) {
              return t.done ? t.value : a.next();
            });
      }),
      P(S),
      f(S, l, 'Generator'),
      f(S, u, function () {
        return this;
      }),
      f(S, 'toString', function () {
        return '[object Generator]';
      }),
      (e.keys = function (t) {
        var e = Object(t),
          r = [];
        for (var n in e) r.push(n);
        return (
          r.reverse(),
          function t() {
            for (; r.length; ) {
              var n = r.pop();
              if (n in e) return (t.value = n), (t.done = !1), t;
            }
            return (t.done = !0), t;
          }
        );
      }),
      (e.values = I),
      (A.prototype = {
        constructor: A,
        reset: function (e) {
          if (
            ((this.prev = 0),
            (this.next = 0),
            (this.sent = this._sent = t),
            (this.done = !1),
            (this.delegate = null),
            (this.method = 'next'),
            (this.arg = t),
            this.tryEntries.forEach(N),
            !e)
          )
            for (var r in this) 't' === r.charAt(0) && i.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function () {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ('throw' === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function (e) {
          if (this.done) throw e;
          var r = this;
          function n(n, o) {
            return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
          }
          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var a = this.tryEntries[o],
              c = a.completion;
            if ('root' === a.tryLoc) return n('end');
            if (a.tryLoc <= this.prev) {
              var u = i.call(a, 'catchLoc'),
                s = i.call(a, 'finallyLoc');
              if (u && s) {
                if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return n(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
              } else {
                if (!s) throw new Error('try statement without catch or finally');
                if (this.prev < a.finallyLoc) return n(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var n = this.tryEntries[r];
            if (n.tryLoc <= this.prev && i.call(n, 'finallyLoc') && this.prev < n.finallyLoc) {
              var o = n;
              break;
            }
          }
          o && ('break' === t || 'continue' === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return (
            (a.type = t), (a.arg = e), o ? ((this.method = 'next'), (this.next = o.finallyLoc), m) : this.complete(a)
          );
        },
        complete: function (t, e) {
          if ('throw' === t.type) throw t.arg;
          return (
            'break' === t.type || 'continue' === t.type
              ? (this.next = t.arg)
              : 'return' === t.type
              ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
              : 'normal' === t.type && e && (this.next = e),
            m
          );
        },
        finish: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), N(r), m;
          }
        },
        catch: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.tryLoc === t) {
              var n = r.completion;
              if ('throw' === n.type) {
                var o = n.arg;
                N(r);
              }
              return o;
            }
          }
          throw new Error('illegal catch attempt');
        },
        delegateYield: function (e, r, n) {
          return (
            (this.delegate = { iterator: I(e), resultName: r, nextLoc: n }), 'next' === this.method && (this.arg = t), m
          );
        },
      }),
      e
    );
  }
  function o(t, e, r, n, o, i, a) {
    try {
      var c = t[i](a),
        u = c.value;
    } catch (t) {
      return void r(t);
    }
    c.done ? e(u) : Promise.resolve(u).then(n, o);
  }
  function i(t) {
    return function () {
      var e = this,
        r = arguments;
      return new Promise(function (n, i) {
        var a = t.apply(e, r);
        function c(t) {
          o(a, n, i, c, u, 'next', t);
        }
        function u(t) {
          o(a, n, i, c, u, 'throw', t);
        }
        c(void 0);
      });
    };
  }
  t.r(e),
    t.d(e, {
      CURRENT_POSITION: () => L,
      DEFAULT_POSITION: () => x,
      DEPRECATED__createStoreOpeningTimeText: () => jt,
      DEPRECATED__getStoreOpeningTime: () => kt,
      USER_POSITION: () => E,
      USER_POSITION_CONSENT: () => b,
      USER_STORAGE_CONSENT: () => w,
      _defaultPosition: () => J,
      api: () => c,
      createAutocompleteHandler: () => y,
      createDebounceFn: () => A,
      createExpirationValue: () => N,
      createPosition: () => W,
      createThrottleFn: () => I,
      delay: () => j,
      fetchProductAvailabilities: () => dt,
      fetchUserDefaultPosition: () => $,
      fetchUserPosition: () => V,
      findNearestStore: () => St,
      from12to24Hours: () => R,
      from24to12Hours: () => G,
      getDevice: () => d,
      getDistanceText: () => Ot,
      getExpirable: () => m,
      getRadialDistanceFn: () => tt,
      getStoreOpeningTime: () => D,
      isInViewport: () => Pt,
      isPositionInBounds: () => et,
      positionToLatLngLiteral: () => rt,
      positionToLatLngPair: () => nt,
      report: () => U,
      retailTuneAutocompleteHandler: () => v,
      sendIsochronePolygonalEvents: () => st,
      sendProximityEvents: () => ut,
      setExpirable: () => g,
      sortStoresByDistance: () => Et,
      sortStoresByPriority: () => Lt,
      updateWidgetState: () => gt,
    });
  var a = { development: 'api.retailtune.com', production: 'api.retailtune.com' },
    c = {
      origin: 'https://' + a.development,
      setOrigin: function (t) {
        switch (t.type) {
          case 'production':
          case 'development':
            this.origin = 'https://' + a[t.type];
            break;
          case 'custom':
            this.origin = 'https://' + t.hostname;
        }
      },
      fetchHostnames: function (t) {
        var e = this;
        return i(
          n().mark(function r() {
            var o, i, a;
            return n().wrap(function (r) {
              for (;;)
                switch ((r.prev = r.next)) {
                  case 0:
                    return (r.next = 2), fetch(''.concat(e.origin, '/v1/validate-hostname?rt_api_key=').concat(t));
                  case 2:
                    if ((o = r.sent).ok) {
                      r.next = 5;
                      break;
                    }
                    throw new Error('Fetch failed: HTTP status '.concat(o.status));
                  case 5:
                    return (r.next = 7), o.json();
                  case 7:
                    for (a in (i = r.sent)) i[a] = 'https://'.concat(i[a]);
                    return r.abrupt('return', i);
                  case 10:
                  case 'end':
                    return r.stop();
                }
            }, r);
          }),
        )();
      },
      fetchPageData: function (t, e) {
        var r = this;
        return i(
          n().mark(function o() {
            var i;
            return n().wrap(function (n) {
              for (;;)
                switch ((n.prev = n.next)) {
                  case 0:
                    return (
                      (n.next = 2), fetch(''.concat(r.origin, '/storelocator/').concat(e, '/?rt_api_key=').concat(t))
                    );
                  case 2:
                    if ((i = n.sent).ok) {
                      n.next = 5;
                      break;
                    }
                    throw new Error('Fetch failed: HTTP status '.concat(i.status));
                  case 5:
                    return n.abrupt('return', i.json());
                  case 6:
                  case 'end':
                    return n.stop();
                }
            }, o);
          }),
        )();
      },
      defaultPositionGetURL: function () {
        return ''.concat(this.origin, '/v1/default-positions/get');
      },
      geocodeURL: function () {
        return ''.concat(this.origin, '/geocode');
      },
      intersectingIsochronesGetURL: function () {
        return ''.concat(this.origin, '/v1/intersecting-isochrones/get');
      },
      productAvailabilityInStoresURL: function () {
        return ''.concat(this.origin, '/api/v1/estore/is-product-available-in-stores');
      },
    };
  function u(t) {
    return (
      (u =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            }),
      u(t)
    );
  }
  function s(t, e) {
    var r = ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
    if (!r) {
      if (
        Array.isArray(t) ||
        (r = (function (t, e) {
          if (t) {
            if ('string' == typeof t) return l(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return (
              'Object' === r && t.constructor && (r = t.constructor.name),
              'Map' === r || 'Set' === r
                ? Array.from(t)
                : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                ? l(t, e)
                : void 0
            );
          }
        })(t)) ||
        (e && t && 'number' == typeof t.length)
      ) {
        r && (t = r);
        var n = 0,
          o = function () {};
        return {
          s: o,
          n: function () {
            return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
          },
          e: function (t) {
            throw t;
          },
          f: o,
        };
      }
      throw new TypeError(
        'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
      );
    }
    var i,
      a = !0,
      c = !1;
    return {
      s: function () {
        r = r.call(t);
      },
      n: function () {
        var t = r.next();
        return (a = t.done), t;
      },
      e: function (t) {
        (c = !0), (i = t);
      },
      f: function () {
        try {
          a || null == r.return || r.return();
        } finally {
          if (c) throw i;
        }
      },
    };
  }
  function l(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
    return n;
  }
  function f() {
    f = function () {
      return e;
    };
    var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o =
        Object.defineProperty ||
        function (t, e, r) {
          t[e] = r.value;
        },
      i = 'function' == typeof Symbol ? Symbol : {},
      a = i.iterator || '@@iterator',
      c = i.asyncIterator || '@@asyncIterator',
      s = i.toStringTag || '@@toStringTag';
    function l(t, e, r) {
      return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
    }
    try {
      l({}, '');
    } catch (t) {
      l = function (t, e, r) {
        return (t[e] = r);
      };
    }
    function h(t, e, r, n) {
      var i = e && e.prototype instanceof w ? e : w,
        a = Object.create(i.prototype),
        c = new A(n || []);
      return o(a, '_invoke', { value: T(t, r, c) }), a;
    }
    function p(t, e, r) {
      try {
        return { type: 'normal', arg: t.call(e, r) };
      } catch (t) {
        return { type: 'throw', arg: t };
      }
    }
    e.wrap = h;
    var y = 'suspendedStart',
      v = 'suspendedYield',
      d = 'executing',
      g = 'completed',
      m = {};
    function w() {}
    function b() {}
    function x() {}
    var E = {};
    l(E, a, function () {
      return this;
    });
    var L = Object.getPrototypeOf,
      O = L && L(L(I([])));
    O && O !== r && n.call(O, a) && (E = O);
    var S = (x.prototype = w.prototype = Object.create(E));
    function P(t) {
      ['next', 'throw', 'return'].forEach(function (e) {
        l(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function _(t, e) {
      function r(o, i, a, c) {
        var s = p(t[o], t, i);
        if ('throw' !== s.type) {
          var l = s.arg,
            f = l.value;
          return f && 'object' == u(f) && n.call(f, '__await')
            ? e.resolve(f.__await).then(
                function (t) {
                  r('next', t, a, c);
                },
                function (t) {
                  r('throw', t, a, c);
                },
              )
            : e.resolve(f).then(
                function (t) {
                  (l.value = t), a(l);
                },
                function (t) {
                  return r('throw', t, a, c);
                },
              );
        }
        c(s.arg);
      }
      var i;
      o(this, '_invoke', {
        value: function (t, n) {
          function o() {
            return new e(function (e, o) {
              r(t, n, e, o);
            });
          }
          return (i = i ? i.then(o, o) : o());
        },
      });
    }
    function T(e, r, n) {
      var o = y;
      return function (i, a) {
        if (o === d) throw new Error('Generator is already running');
        if (o === g) {
          if ('throw' === i) throw a;
          return { value: t, done: !0 };
        }
        for (n.method = i, n.arg = a; ; ) {
          var c = n.delegate;
          if (c) {
            var u = j(c, n);
            if (u) {
              if (u === m) continue;
              return u;
            }
          }
          if ('next' === n.method) n.sent = n._sent = n.arg;
          else if ('throw' === n.method) {
            if (o === y) throw ((o = g), n.arg);
            n.dispatchException(n.arg);
          } else 'return' === n.method && n.abrupt('return', n.arg);
          o = d;
          var s = p(e, r, n);
          if ('normal' === s.type) {
            if (((o = n.done ? g : v), s.arg === m)) continue;
            return { value: s.arg, done: n.done };
          }
          'throw' === s.type && ((o = g), (n.method = 'throw'), (n.arg = s.arg));
        }
      };
    }
    function j(e, r) {
      var n = r.method,
        o = e.iterator[n];
      if (o === t)
        return (
          (r.delegate = null),
          ('throw' === n && e.iterator.return && ((r.method = 'return'), (r.arg = t), j(e, r), 'throw' === r.method)) ||
            ('return' !== n &&
              ((r.method = 'throw'), (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
          m
        );
      var i = p(o, e.iterator, r.arg);
      if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), m;
      var a = i.arg;
      return a
        ? a.done
          ? ((r[e.resultName] = a.value),
            (r.next = e.nextLoc),
            'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
            (r.delegate = null),
            m)
          : a
        : ((r.method = 'throw'), (r.arg = new TypeError('iterator result is not an object')), (r.delegate = null), m);
    }
    function k(t) {
      var e = { tryLoc: t[0] };
      1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
    }
    function N(t) {
      var e = t.completion || {};
      (e.type = 'normal'), delete e.arg, (t.completion = e);
    }
    function A(t) {
      (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(k, this), this.reset(!0);
    }
    function I(e) {
      if (e || '' === e) {
        var r = e[a];
        if (r) return r.call(e);
        if ('function' == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            i = function r() {
              for (; ++o < e.length; ) if (n.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
              return (r.value = t), (r.done = !0), r;
            };
          return (i.next = i);
        }
      }
      throw new TypeError(u(e) + ' is not iterable');
    }
    return (
      (b.prototype = x),
      o(S, 'constructor', { value: x, configurable: !0 }),
      o(x, 'constructor', { value: b, configurable: !0 }),
      (b.displayName = l(x, s, 'GeneratorFunction')),
      (e.isGeneratorFunction = function (t) {
        var e = 'function' == typeof t && t.constructor;
        return !!e && (e === b || 'GeneratorFunction' === (e.displayName || e.name));
      }),
      (e.mark = function (t) {
        return (
          Object.setPrototypeOf ? Object.setPrototypeOf(t, x) : ((t.__proto__ = x), l(t, s, 'GeneratorFunction')),
          (t.prototype = Object.create(S)),
          t
        );
      }),
      (e.awrap = function (t) {
        return { __await: t };
      }),
      P(_.prototype),
      l(_.prototype, c, function () {
        return this;
      }),
      (e.AsyncIterator = _),
      (e.async = function (t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new _(h(t, r, n, o), i);
        return e.isGeneratorFunction(r)
          ? a
          : a.next().then(function (t) {
              return t.done ? t.value : a.next();
            });
      }),
      P(S),
      l(S, s, 'Generator'),
      l(S, a, function () {
        return this;
      }),
      l(S, 'toString', function () {
        return '[object Generator]';
      }),
      (e.keys = function (t) {
        var e = Object(t),
          r = [];
        for (var n in e) r.push(n);
        return (
          r.reverse(),
          function t() {
            for (; r.length; ) {
              var n = r.pop();
              if (n in e) return (t.value = n), (t.done = !1), t;
            }
            return (t.done = !0), t;
          }
        );
      }),
      (e.values = I),
      (A.prototype = {
        constructor: A,
        reset: function (e) {
          if (
            ((this.prev = 0),
            (this.next = 0),
            (this.sent = this._sent = t),
            (this.done = !1),
            (this.delegate = null),
            (this.method = 'next'),
            (this.arg = t),
            this.tryEntries.forEach(N),
            !e)
          )
            for (var r in this) 't' === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function () {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ('throw' === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function (e) {
          if (this.done) throw e;
          var r = this;
          function o(n, o) {
            return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
              c = a.completion;
            if ('root' === a.tryLoc) return o('end');
            if (a.tryLoc <= this.prev) {
              var u = n.call(a, 'catchLoc'),
                s = n.call(a, 'finallyLoc');
              if (u && s) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!s) throw new Error('try statement without catch or finally');
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];
            if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return (
            (a.type = t), (a.arg = e), i ? ((this.method = 'next'), (this.next = i.finallyLoc), m) : this.complete(a)
          );
        },
        complete: function (t, e) {
          if ('throw' === t.type) throw t.arg;
          return (
            'break' === t.type || 'continue' === t.type
              ? (this.next = t.arg)
              : 'return' === t.type
              ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
              : 'normal' === t.type && e && (this.next = e),
            m
          );
        },
        finish: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), N(r), m;
          }
        },
        catch: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.tryLoc === t) {
              var n = r.completion;
              if ('throw' === n.type) {
                var o = n.arg;
                N(r);
              }
              return o;
            }
          }
          throw new Error('illegal catch attempt');
        },
        delegateYield: function (e, r, n) {
          return (
            (this.delegate = { iterator: I(e), resultName: r, nextLoc: n }), 'next' === this.method && (this.arg = t), m
          );
        },
      }),
      e
    );
  }
  function h(t, e, r, n, o, i, a) {
    try {
      var c = t[i](a),
        u = c.value;
    } catch (t) {
      return void r(t);
    }
    c.done ? e(u) : Promise.resolve(u).then(n, o);
  }
  function p(t) {
    return function () {
      var e = this,
        r = arguments;
      return new Promise(function (n, o) {
        var i = t.apply(e, r);
        function a(t) {
          h(i, n, o, a, c, 'next', t);
        }
        function c(t) {
          h(i, n, o, a, c, 'throw', t);
        }
        a(void 0);
      });
    };
  }
  function y() {
    for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
    return (function () {
      var t = p(
        f().mark(function t(r) {
          var n, o, i, a;
          return f().wrap(
            function (t) {
              for (;;)
                switch ((t.prev = t.next)) {
                  case 0:
                    (n = 0), (o = e);
                  case 1:
                    if (!(n < o.length)) {
                      t.next = 21;
                      break;
                    }
                    return (i = o[n]), (t.prev = 3), (t.next = 6), i(r);
                  case 6:
                    if ('ok' !== (a = t.sent).type) {
                      t.next = 9;
                      break;
                    }
                    return t.abrupt('return', a.data);
                  case 9:
                    if ('error' !== a.type) {
                      t.next = 11;
                      break;
                    }
                    return t.abrupt('continue', 18);
                  case 11:
                    return console.error('[AUTOCOMPLETE-ERROR]: prediction type is invalid'), t.abrupt('break', 21);
                  case 15:
                    (t.prev = 15),
                      (t.t0 = t.catch(3)),
                      console.error('[AUTOCOMPLETE-ERROR]: '.concat(JSON.stringify(t.t0)));
                  case 18:
                    n++, (t.next = 1);
                    break;
                  case 21:
                    return (
                      console.error('[AUTOCOMPLETE-ERROR]: no API was able to find a result'), t.abrupt('return', [])
                    );
                  case 23:
                  case 'end':
                    return t.stop();
                }
            },
            t,
            null,
            [[3, 15]],
          );
        }),
      );
      return function (e) {
        return t.apply(this, arguments);
      };
    })();
  }
  function v(t, e) {
    var r = { type: 'autocomplete', text: '', lang: 'en', layers: ['postalcode', 'street', 'locality', 'country'] };
    return (
      e &&
        (e.language && (r.lang = e.language),
        e.layers && (r.layers = e.layers),
        e.countries && (r.countries = e.countries),
        e.focalPoint && ((r.lat = e.focalPoint.latitude.toString()), (r.lon = e.focalPoint.longitude.toString()))),
      (function () {
        var e = p(
          f().mark(function e(n) {
            var o, i, a, u, l, h;
            return f().wrap(function (e) {
              for (;;)
                switch ((e.prev = e.next)) {
                  case 0:
                    return (
                      (r.text = n),
                      (e.next = 3),
                      fetch(c.geocodeURL(), {
                        method: 'POST',
                        headers: { Accept: 'application/json', Authorization: 'Bearer '.concat(t) },
                        body: JSON.stringify(r),
                      })
                    );
                  case 3:
                    if (200 === (o = e.sent).status) {
                      e.next = 6;
                      break;
                    }
                    return e.abrupt('return', { type: 'error', message: 'Axios response status: '.concat(o.status) });
                  case 6:
                    return (e.next = 8), o.json();
                  case 8:
                    if ('error' !== (i = e.sent).status) {
                      e.next = 11;
                      break;
                    }
                    return e.abrupt('return', {
                      type: 'error',
                      message: 'RT-API responded with status: '.concat(i.status),
                    });
                  case 11:
                    if ('ok' !== i.status) {
                      e.next = 16;
                      break;
                    }
                    (a = []), (u = s(i.items));
                    try {
                      for (u.s(); !(l = u.n()).done; )
                        (h = l.value),
                          a.push({ description: h.item, latitude: +h.lat, longitude: +h.lon, layer: h.layer });
                    } catch (t) {
                      u.e(t);
                    } finally {
                      u.f();
                    }
                    return e.abrupt('return', { type: 'ok', data: a });
                  case 16:
                    return e.abrupt('return', { type: 'error', message: 'Unexpected RT-API response status' });
                  case 17:
                  case 'end':
                    return e.stop();
                }
            }, e);
          }),
        );
        return function (t) {
          return e.apply(this, arguments);
        };
      })()
    );
  }
  function d() {
    return window.innerWidth < 768 ? 'mobile' : window.innerWidth < 991 ? 'tablet' : 'desktop';
  }
  function g(t, e) {
    localStorage.setItem(t, JSON.stringify(e));
  }
  function m(t) {
    var e = localStorage.getItem(t);
    if (!e) return null;
    var r,
      n,
      o = JSON.parse(e);
    return (
      (r = o),
      Object.getOwnPropertyNames(r).includes('expiration')
        ? ((n = o), new Date() > new Date(n.expiration) ? (localStorage.removeItem(t), null) : JSON.parse(o.value))
        : null
    );
  }
  var w = 'storage-usage-consent',
    b = 'user-position-usage-consent',
    x = 'default-position',
    E = 'user-position',
    L = 'current-position';
  function O(t) {
    return (
      (O =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            }),
      O(t)
    );
  }
  function S() {
    S = function () {
      return e;
    };
    var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o =
        Object.defineProperty ||
        function (t, e, r) {
          t[e] = r.value;
        },
      i = 'function' == typeof Symbol ? Symbol : {},
      a = i.iterator || '@@iterator',
      c = i.asyncIterator || '@@asyncIterator',
      u = i.toStringTag || '@@toStringTag';
    function s(t, e, r) {
      return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
    }
    try {
      s({}, '');
    } catch (t) {
      s = function (t, e, r) {
        return (t[e] = r);
      };
    }
    function l(t, e, r, n) {
      var i = e && e.prototype instanceof g ? e : g,
        a = Object.create(i.prototype),
        c = new A(n || []);
      return o(a, '_invoke', { value: T(t, r, c) }), a;
    }
    function f(t, e, r) {
      try {
        return { type: 'normal', arg: t.call(e, r) };
      } catch (t) {
        return { type: 'throw', arg: t };
      }
    }
    e.wrap = l;
    var h = 'suspendedStart',
      p = 'suspendedYield',
      y = 'executing',
      v = 'completed',
      d = {};
    function g() {}
    function m() {}
    function w() {}
    var b = {};
    s(b, a, function () {
      return this;
    });
    var x = Object.getPrototypeOf,
      E = x && x(x(I([])));
    E && E !== r && n.call(E, a) && (b = E);
    var L = (w.prototype = g.prototype = Object.create(b));
    function P(t) {
      ['next', 'throw', 'return'].forEach(function (e) {
        s(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function _(t, e) {
      function r(o, i, a, c) {
        var u = f(t[o], t, i);
        if ('throw' !== u.type) {
          var s = u.arg,
            l = s.value;
          return l && 'object' == O(l) && n.call(l, '__await')
            ? e.resolve(l.__await).then(
                function (t) {
                  r('next', t, a, c);
                },
                function (t) {
                  r('throw', t, a, c);
                },
              )
            : e.resolve(l).then(
                function (t) {
                  (s.value = t), a(s);
                },
                function (t) {
                  return r('throw', t, a, c);
                },
              );
        }
        c(u.arg);
      }
      var i;
      o(this, '_invoke', {
        value: function (t, n) {
          function o() {
            return new e(function (e, o) {
              r(t, n, e, o);
            });
          }
          return (i = i ? i.then(o, o) : o());
        },
      });
    }
    function T(e, r, n) {
      var o = h;
      return function (i, a) {
        if (o === y) throw new Error('Generator is already running');
        if (o === v) {
          if ('throw' === i) throw a;
          return { value: t, done: !0 };
        }
        for (n.method = i, n.arg = a; ; ) {
          var c = n.delegate;
          if (c) {
            var u = j(c, n);
            if (u) {
              if (u === d) continue;
              return u;
            }
          }
          if ('next' === n.method) n.sent = n._sent = n.arg;
          else if ('throw' === n.method) {
            if (o === h) throw ((o = v), n.arg);
            n.dispatchException(n.arg);
          } else 'return' === n.method && n.abrupt('return', n.arg);
          o = y;
          var s = f(e, r, n);
          if ('normal' === s.type) {
            if (((o = n.done ? v : p), s.arg === d)) continue;
            return { value: s.arg, done: n.done };
          }
          'throw' === s.type && ((o = v), (n.method = 'throw'), (n.arg = s.arg));
        }
      };
    }
    function j(e, r) {
      var n = r.method,
        o = e.iterator[n];
      if (o === t)
        return (
          (r.delegate = null),
          ('throw' === n && e.iterator.return && ((r.method = 'return'), (r.arg = t), j(e, r), 'throw' === r.method)) ||
            ('return' !== n &&
              ((r.method = 'throw'), (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
          d
        );
      var i = f(o, e.iterator, r.arg);
      if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), d;
      var a = i.arg;
      return a
        ? a.done
          ? ((r[e.resultName] = a.value),
            (r.next = e.nextLoc),
            'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
            (r.delegate = null),
            d)
          : a
        : ((r.method = 'throw'), (r.arg = new TypeError('iterator result is not an object')), (r.delegate = null), d);
    }
    function k(t) {
      var e = { tryLoc: t[0] };
      1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
    }
    function N(t) {
      var e = t.completion || {};
      (e.type = 'normal'), delete e.arg, (t.completion = e);
    }
    function A(t) {
      (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(k, this), this.reset(!0);
    }
    function I(e) {
      if (e || '' === e) {
        var r = e[a];
        if (r) return r.call(e);
        if ('function' == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            i = function r() {
              for (; ++o < e.length; ) if (n.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
              return (r.value = t), (r.done = !0), r;
            };
          return (i.next = i);
        }
      }
      throw new TypeError(O(e) + ' is not iterable');
    }
    return (
      (m.prototype = w),
      o(L, 'constructor', { value: w, configurable: !0 }),
      o(w, 'constructor', { value: m, configurable: !0 }),
      (m.displayName = s(w, u, 'GeneratorFunction')),
      (e.isGeneratorFunction = function (t) {
        var e = 'function' == typeof t && t.constructor;
        return !!e && (e === m || 'GeneratorFunction' === (e.displayName || e.name));
      }),
      (e.mark = function (t) {
        return (
          Object.setPrototypeOf ? Object.setPrototypeOf(t, w) : ((t.__proto__ = w), s(t, u, 'GeneratorFunction')),
          (t.prototype = Object.create(L)),
          t
        );
      }),
      (e.awrap = function (t) {
        return { __await: t };
      }),
      P(_.prototype),
      s(_.prototype, c, function () {
        return this;
      }),
      (e.AsyncIterator = _),
      (e.async = function (t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new _(l(t, r, n, o), i);
        return e.isGeneratorFunction(r)
          ? a
          : a.next().then(function (t) {
              return t.done ? t.value : a.next();
            });
      }),
      P(L),
      s(L, u, 'Generator'),
      s(L, a, function () {
        return this;
      }),
      s(L, 'toString', function () {
        return '[object Generator]';
      }),
      (e.keys = function (t) {
        var e = Object(t),
          r = [];
        for (var n in e) r.push(n);
        return (
          r.reverse(),
          function t() {
            for (; r.length; ) {
              var n = r.pop();
              if (n in e) return (t.value = n), (t.done = !1), t;
            }
            return (t.done = !0), t;
          }
        );
      }),
      (e.values = I),
      (A.prototype = {
        constructor: A,
        reset: function (e) {
          if (
            ((this.prev = 0),
            (this.next = 0),
            (this.sent = this._sent = t),
            (this.done = !1),
            (this.delegate = null),
            (this.method = 'next'),
            (this.arg = t),
            this.tryEntries.forEach(N),
            !e)
          )
            for (var r in this) 't' === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function () {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ('throw' === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function (e) {
          if (this.done) throw e;
          var r = this;
          function o(n, o) {
            return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
              c = a.completion;
            if ('root' === a.tryLoc) return o('end');
            if (a.tryLoc <= this.prev) {
              var u = n.call(a, 'catchLoc'),
                s = n.call(a, 'finallyLoc');
              if (u && s) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!s) throw new Error('try statement without catch or finally');
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];
            if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return (
            (a.type = t), (a.arg = e), i ? ((this.method = 'next'), (this.next = i.finallyLoc), d) : this.complete(a)
          );
        },
        complete: function (t, e) {
          if ('throw' === t.type) throw t.arg;
          return (
            'break' === t.type || 'continue' === t.type
              ? (this.next = t.arg)
              : 'return' === t.type
              ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
              : 'normal' === t.type && e && (this.next = e),
            d
          );
        },
        finish: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), N(r), d;
          }
        },
        catch: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.tryLoc === t) {
              var n = r.completion;
              if ('throw' === n.type) {
                var o = n.arg;
                N(r);
              }
              return o;
            }
          }
          throw new Error('illegal catch attempt');
        },
        delegateYield: function (e, r, n) {
          return (
            (this.delegate = { iterator: I(e), resultName: r, nextLoc: n }), 'next' === this.method && (this.arg = t), d
          );
        },
      }),
      e
    );
  }
  function P(t, e) {
    return (
      (function (t) {
        if (Array.isArray(t)) return t;
      })(t) ||
      (function (t, e) {
        var r = null == t ? null : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
        if (null != r) {
          var n,
            o,
            i,
            a,
            c = [],
            u = !0,
            s = !1;
          try {
            if (((i = (r = r.call(t)).next), 0 === e)) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== e); u = !0);
          } catch (t) {
            (s = !0), (o = t);
          } finally {
            try {
              if (!u && null != r.return && ((a = r.return()), Object(a) !== a)) return;
            } finally {
              if (s) throw o;
            }
          }
          return c;
        }
      })(t, e) ||
      (function (t, e) {
        if (t) {
          if ('string' == typeof t) return _(t, e);
          var r = Object.prototype.toString.call(t).slice(8, -1);
          return (
            'Object' === r && t.constructor && (r = t.constructor.name),
            'Map' === r || 'Set' === r
              ? Array.from(t)
              : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
              ? _(t, e)
              : void 0
          );
        }
      })(t, e) ||
      (function () {
        throw new TypeError(
          'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
        );
      })()
    );
  }
  function _(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
    return n;
  }
  function T(t, e, r, n, o, i, a) {
    try {
      var c = t[i](a),
        u = c.value;
    } catch (t) {
      return void r(t);
    }
    c.done ? e(u) : Promise.resolve(u).then(n, o);
  }
  function j(t) {
    return k.apply(this, arguments);
  }
  function k() {
    var t;
    return (
      (t = S().mark(function t(e) {
        return S().wrap(function (t) {
          for (;;)
            switch ((t.prev = t.next)) {
              case 0:
                return t.abrupt(
                  'return',
                  new Promise(function (t) {
                    setTimeout(t, e);
                  }),
                );
              case 1:
              case 'end':
                return t.stop();
            }
        }, t);
      })),
      (k = function () {
        var e = this,
          r = arguments;
        return new Promise(function (n, o) {
          var i = t.apply(e, r);
          function a(t) {
            T(i, n, o, a, c, 'next', t);
          }
          function c(t) {
            T(i, n, o, a, c, 'throw', t);
          }
          a(void 0);
        });
      }),
      k.apply(this, arguments)
    );
  }
  function N(t, e) {
    switch (e) {
      case 'minutes':
        return Date.now() + 60 * t * 1e3;
      case 'hours':
        return Date.now() + 60 * t * 1e3 * 60;
      case 'days':
        return Date.now() + 60 * t * 1e3 * 60 * 24;
      case 'months':
        return Date.now() + 60 * t * 1e3 * 60 * 24 * 30;
      case 'years':
        return Date.now() + 60 * t * 1e3 * 60 * 24 * 30 * 12;
      default:
        throw new Error('Expiration type "'.concat(e, '" is not valid'));
    }
  }
  function A() {
    return function (t) {
      var e;
      return function (r) {
        for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) o[i - 1] = arguments[i];
        clearTimeout(e),
          (e = setTimeout(function () {
            return r.apply(void 0, o);
          }, t));
      };
    };
  }
  function I() {
    return function (t) {
      var e = !1;
      return function (r) {
        for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) o[i - 1] = arguments[i];
        e ||
          ((e = !0),
          setTimeout(function () {
            r.apply(void 0, o), (e = !1);
          }, t));
      };
    };
  }
  function G(t) {
    var e = P(
        (t = t.trim()).split(':').map(function (t) {
          return parseInt(t);
        }),
        2,
      ),
      r = e[0],
      n = e[1],
      o = r >= 12 ? 'PM' : 'AM';
    r > 12 && (r -= 12);
    var i = r < 10 ? '0'.concat(r) : r,
      a = n < 10 ? '0'.concat(n) : n;
    return ''.concat(i, ':').concat(a, ' ').concat(o);
  }
  function R(t) {
    var e = (t = t.trim()).slice(-2, t.length),
      r = P(
        t
          .slice(0, t.length - 2)
          .split(':')
          .map(function (t) {
            return parseInt(t);
          }),
        2,
      ),
      n = r[0],
      o = r[1];
    'PM' === e && (n += 12);
    var i = n < 10 ? '0'.concat(n) : n,
      a = o < 10 ? '0'.concat(o) : o;
    return ''.concat(i, ':').concat(a);
  }
  function D(t) {
    var e = t.serverTime,
      r = t.store,
      n = t.format,
      o = t.hoursSeparator,
      i = void 0 === o ? '-' : o,
      a = t.openingsSeparator,
      c = void 0 === a ? ',' : a;
    try {
      var u = e,
        s = 1e3 * r.hourOffset,
        l = new Date(u + s),
        f = r.openingHours[l.getDay()];
      if (!f) return { status: 'unknown' };
      if (0 === f.length) return { status: 'closed' };
      var h = P(f, 2),
        p = h[0],
        y = h[1];
      '12h' === n && (p = p.map(G));
      var v = ''.concat(p[0], ' ').concat(i, ' ').concat(p[1]);
      return (
        y && ('12h' === n && (y = y.map(G)), (v += ' '.concat(c, ' ').concat(y[0], ' ').concat(i, ' ').concat(y[1]))),
        { status: 'ok', text: v }
      );
    } catch (t) {
      return { status: 'error', message: 'Cannot create opening text for store id='.concat(r.id) };
    }
  }
  function U(t, e) {
    switch (t) {
      case 'critical':
        throw new Error(e);
      case 'error':
        return console.error(e);
      case 'warning':
        return console.warn(e);
      default:
        console.log(e);
    }
  }
  function F(t) {
    return (
      (F =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            }),
      F(t)
    );
  }
  function C() {
    C = function () {
      return e;
    };
    var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o =
        Object.defineProperty ||
        function (t, e, r) {
          t[e] = r.value;
        },
      i = 'function' == typeof Symbol ? Symbol : {},
      a = i.iterator || '@@iterator',
      c = i.asyncIterator || '@@asyncIterator',
      u = i.toStringTag || '@@toStringTag';
    function s(t, e, r) {
      return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
    }
    try {
      s({}, '');
    } catch (t) {
      s = function (t, e, r) {
        return (t[e] = r);
      };
    }
    function l(t, e, r, n) {
      var i = e && e.prototype instanceof g ? e : g,
        a = Object.create(i.prototype),
        c = new k(n || []);
      return o(a, '_invoke', { value: P(t, r, c) }), a;
    }
    function f(t, e, r) {
      try {
        return { type: 'normal', arg: t.call(e, r) };
      } catch (t) {
        return { type: 'throw', arg: t };
      }
    }
    e.wrap = l;
    var h = 'suspendedStart',
      p = 'suspendedYield',
      y = 'executing',
      v = 'completed',
      d = {};
    function g() {}
    function m() {}
    function w() {}
    var b = {};
    s(b, a, function () {
      return this;
    });
    var x = Object.getPrototypeOf,
      E = x && x(x(N([])));
    E && E !== r && n.call(E, a) && (b = E);
    var L = (w.prototype = g.prototype = Object.create(b));
    function O(t) {
      ['next', 'throw', 'return'].forEach(function (e) {
        s(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function S(t, e) {
      function r(o, i, a, c) {
        var u = f(t[o], t, i);
        if ('throw' !== u.type) {
          var s = u.arg,
            l = s.value;
          return l && 'object' == F(l) && n.call(l, '__await')
            ? e.resolve(l.__await).then(
                function (t) {
                  r('next', t, a, c);
                },
                function (t) {
                  r('throw', t, a, c);
                },
              )
            : e.resolve(l).then(
                function (t) {
                  (s.value = t), a(s);
                },
                function (t) {
                  return r('throw', t, a, c);
                },
              );
        }
        c(u.arg);
      }
      var i;
      o(this, '_invoke', {
        value: function (t, n) {
          function o() {
            return new e(function (e, o) {
              r(t, n, e, o);
            });
          }
          return (i = i ? i.then(o, o) : o());
        },
      });
    }
    function P(e, r, n) {
      var o = h;
      return function (i, a) {
        if (o === y) throw new Error('Generator is already running');
        if (o === v) {
          if ('throw' === i) throw a;
          return { value: t, done: !0 };
        }
        for (n.method = i, n.arg = a; ; ) {
          var c = n.delegate;
          if (c) {
            var u = _(c, n);
            if (u) {
              if (u === d) continue;
              return u;
            }
          }
          if ('next' === n.method) n.sent = n._sent = n.arg;
          else if ('throw' === n.method) {
            if (o === h) throw ((o = v), n.arg);
            n.dispatchException(n.arg);
          } else 'return' === n.method && n.abrupt('return', n.arg);
          o = y;
          var s = f(e, r, n);
          if ('normal' === s.type) {
            if (((o = n.done ? v : p), s.arg === d)) continue;
            return { value: s.arg, done: n.done };
          }
          'throw' === s.type && ((o = v), (n.method = 'throw'), (n.arg = s.arg));
        }
      };
    }
    function _(e, r) {
      var n = r.method,
        o = e.iterator[n];
      if (o === t)
        return (
          (r.delegate = null),
          ('throw' === n && e.iterator.return && ((r.method = 'return'), (r.arg = t), _(e, r), 'throw' === r.method)) ||
            ('return' !== n &&
              ((r.method = 'throw'), (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
          d
        );
      var i = f(o, e.iterator, r.arg);
      if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), d;
      var a = i.arg;
      return a
        ? a.done
          ? ((r[e.resultName] = a.value),
            (r.next = e.nextLoc),
            'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
            (r.delegate = null),
            d)
          : a
        : ((r.method = 'throw'), (r.arg = new TypeError('iterator result is not an object')), (r.delegate = null), d);
    }
    function T(t) {
      var e = { tryLoc: t[0] };
      1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
    }
    function j(t) {
      var e = t.completion || {};
      (e.type = 'normal'), delete e.arg, (t.completion = e);
    }
    function k(t) {
      (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(T, this), this.reset(!0);
    }
    function N(e) {
      if (e || '' === e) {
        var r = e[a];
        if (r) return r.call(e);
        if ('function' == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            i = function r() {
              for (; ++o < e.length; ) if (n.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
              return (r.value = t), (r.done = !0), r;
            };
          return (i.next = i);
        }
      }
      throw new TypeError(F(e) + ' is not iterable');
    }
    return (
      (m.prototype = w),
      o(L, 'constructor', { value: w, configurable: !0 }),
      o(w, 'constructor', { value: m, configurable: !0 }),
      (m.displayName = s(w, u, 'GeneratorFunction')),
      (e.isGeneratorFunction = function (t) {
        var e = 'function' == typeof t && t.constructor;
        return !!e && (e === m || 'GeneratorFunction' === (e.displayName || e.name));
      }),
      (e.mark = function (t) {
        return (
          Object.setPrototypeOf ? Object.setPrototypeOf(t, w) : ((t.__proto__ = w), s(t, u, 'GeneratorFunction')),
          (t.prototype = Object.create(L)),
          t
        );
      }),
      (e.awrap = function (t) {
        return { __await: t };
      }),
      O(S.prototype),
      s(S.prototype, c, function () {
        return this;
      }),
      (e.AsyncIterator = S),
      (e.async = function (t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new S(l(t, r, n, o), i);
        return e.isGeneratorFunction(r)
          ? a
          : a.next().then(function (t) {
              return t.done ? t.value : a.next();
            });
      }),
      O(L),
      s(L, u, 'Generator'),
      s(L, a, function () {
        return this;
      }),
      s(L, 'toString', function () {
        return '[object Generator]';
      }),
      (e.keys = function (t) {
        var e = Object(t),
          r = [];
        for (var n in e) r.push(n);
        return (
          r.reverse(),
          function t() {
            for (; r.length; ) {
              var n = r.pop();
              if (n in e) return (t.value = n), (t.done = !1), t;
            }
            return (t.done = !0), t;
          }
        );
      }),
      (e.values = N),
      (k.prototype = {
        constructor: k,
        reset: function (e) {
          if (
            ((this.prev = 0),
            (this.next = 0),
            (this.sent = this._sent = t),
            (this.done = !1),
            (this.delegate = null),
            (this.method = 'next'),
            (this.arg = t),
            this.tryEntries.forEach(j),
            !e)
          )
            for (var r in this) 't' === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function () {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ('throw' === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function (e) {
          if (this.done) throw e;
          var r = this;
          function o(n, o) {
            return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
              c = a.completion;
            if ('root' === a.tryLoc) return o('end');
            if (a.tryLoc <= this.prev) {
              var u = n.call(a, 'catchLoc'),
                s = n.call(a, 'finallyLoc');
              if (u && s) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!s) throw new Error('try statement without catch or finally');
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];
            if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return (
            (a.type = t), (a.arg = e), i ? ((this.method = 'next'), (this.next = i.finallyLoc), d) : this.complete(a)
          );
        },
        complete: function (t, e) {
          if ('throw' === t.type) throw t.arg;
          return (
            'break' === t.type || 'continue' === t.type
              ? (this.next = t.arg)
              : 'return' === t.type
              ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
              : 'normal' === t.type && e && (this.next = e),
            d
          );
        },
        finish: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), j(r), d;
          }
        },
        catch: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.tryLoc === t) {
              var n = r.completion;
              if ('throw' === n.type) {
                var o = n.arg;
                j(r);
              }
              return o;
            }
          }
          throw new Error('illegal catch attempt');
        },
        delegateYield: function (e, r, n) {
          return (
            (this.delegate = { iterator: N(e), resultName: r, nextLoc: n }), 'next' === this.method && (this.arg = t), d
          );
        },
      }),
      e
    );
  }
  function H(t, e, r, n, o, i, a) {
    try {
      var c = t[i](a),
        u = c.value;
    } catch (t) {
      return void r(t);
    }
    c.done ? e(u) : Promise.resolve(u).then(n, o);
  }
  function M(t) {
    return function () {
      var e = this,
        r = arguments;
      return new Promise(function (n, o) {
        var i = t.apply(e, r);
        function a(t) {
          H(i, n, o, a, c, 'next', t);
        }
        function c(t) {
          H(i, n, o, a, c, 'throw', t);
        }
        a(void 0);
      });
    };
  }
  var B = 6371,
    Y = 2e4,
    J = W({ latitude: 44.8054695, longitude: 10.3367158, type: 'default', origin: 'cached' });
  function W(t) {
    var e, r, n;
    return {
      latitude: t.latitude,
      longitude: t.longitude,
      accuracy: null !== (e = t.accuracy) && void 0 !== e ? e : 1,
      type: null !== (r = t.type) && void 0 !== r ? r : 'fixed',
      origin: null !== (n = t.origin) && void 0 !== n ? n : 'unknown',
    };
  }
  function V(t) {
    return K.apply(this, arguments);
  }
  function K() {
    return (K = M(
      C().mark(function t(e) {
        var r, n;
        return C().wrap(function (t) {
          for (;;)
            switch ((t.prev = t.next)) {
              case 0:
                if (!(r = m(E))) {
                  t.next = 5;
                  break;
                }
                (r.origin = 'cached'), (t.next = 17);
                break;
              case 5:
                return (t.next = 7), z();
              case 7:
                (n = t.sent), (t.t0 = n.type), (t.next = 'error' === t.t0 ? 11 : 'ok' === t.t0 ? 12 : 16);
                break;
              case 11:
                return t.abrupt('break', 17);
              case 12:
                return ((r = n.position).type = 'html5'), (r.origin = 'fetched'), t.abrupt('break', 17);
              case 16:
                U('error', 'Invalid GeolocationResult type (HTML5)');
              case 17:
                return (
                  r || (r = e), g(E, { value: JSON.stringify(r), expiration: N(15, 'minutes') }), t.abrupt('return', r)
                );
              case 20:
              case 'end':
                return t.stop();
            }
        }, t);
      }),
    )).apply(this, arguments);
  }
  function z() {
    if (!navigator.geolocation) throw new Error();
    return new Promise(function (t) {
      navigator.geolocation.getCurrentPosition(
        function (e) {
          if (e.coords.accuracy > Y) return t({ type: 'error', message: 'position accuracy is not enough' });
          var r = W({ latitude: e.coords.latitude, longitude: e.coords.longitude, accuracy: e.coords.accuracy });
          t({ type: 'ok', position: r });
        },
        function (e) {
          return t({ type: 'error', message: e.message });
        },
        { enableHighAccuracy: !0, timeout: 5e3, maximumAge: 0 },
      );
    });
  }
  function $(t) {
    return X.apply(this, arguments);
  }
  function X() {
    return (X = M(
      C().mark(function t(e) {
        var r, n;
        return C().wrap(function (t) {
          for (;;)
            switch ((t.prev = t.next)) {
              case 0:
                if (!(r = m(x))) {
                  t.next = 5;
                  break;
                }
                (r.origin = 'cached'), (t.next = 17);
                break;
              case 5:
                return (t.next = 7), q(e);
              case 7:
                (n = t.sent), (t.t0 = n.type), (t.next = 'error' === t.t0 ? 11 : 'ok' === t.t0 ? 12 : 16);
                break;
              case 11:
                return t.abrupt('break', 17);
              case 12:
                return ((r = n.position).type = 'ip'), (r.origin = 'fetched'), t.abrupt('break', 17);
              case 16:
                U('error', 'Invalid GeolocationResult type (IP)');
              case 17:
                return (
                  r || (r = J), g(x, { value: JSON.stringify(r), expiration: N(1, 'hours') }), t.abrupt('return', r)
                );
              case 20:
              case 'end':
                return t.stop();
            }
        }, t);
      }),
    )).apply(this, arguments);
  }
  function q(t) {
    return Q.apply(this, arguments);
  }
  function Q() {
    return (Q = M(
      C().mark(function t(e) {
        var r, n, o;
        return C().wrap(function (t) {
          for (;;)
            switch ((t.prev = t.next)) {
              case 0:
                return (
                  (t.next = 2),
                  fetch(c.defaultPositionGetURL(), {
                    method: 'POST',
                    headers: { Accept: 'application/json', authorization: 'Bearer '.concat(e) },
                  })
                );
              case 2:
                if (200 === (n = t.sent).status) {
                  t.next = 5;
                  break;
                }
                return t.abrupt('return', { type: 'error', message: '[ERROR]: response status '.concat(n.status) });
              case 5:
                return (t.next = 7), n.json();
              case 7:
                return (
                  (o = t.sent),
                  t.abrupt('return', {
                    type: 'ok',
                    position: W({
                      latitude: o.latitude,
                      longitude: o.longitude,
                      accuracy: null !== (r = o.accuracy) && void 0 !== r ? r : 1,
                    }),
                  })
                );
              case 9:
              case 'end':
                return t.stop();
            }
        }, t);
      }),
    )).apply(this, arguments);
  }
  var Z = function (t) {
    return 0.0174533 * t;
  };
  function tt(t, e) {
    var r = Z(t),
      n = Z(e);
    return function (t, e) {
      var o = Z(t),
        i = Z(e);
      return Math.acos(Math.sin(r) * Math.sin(o) + Math.cos(r) * Math.cos(o) * Math.cos(n - i)) * B * 1e3;
    };
  }
  function et(t, e, r) {
    if (!e || !r) return !0;
    var n = (e.longitude, r.longitude, t.longitude >= r.longitude || t.longitude <= e.longitude);
    return t.latitude >= r.latitude && t.latitude <= e.latitude && n;
  }
  function rt(t) {
    return { lat: t.latitude, lng: t.longitude };
  }
  function nt(t) {
    return [t.latitude, t.longitude];
  }
  function ot(t) {
    return (
      (ot =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            }),
      ot(t)
    );
  }
  function it() {
    it = function () {
      return e;
    };
    var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o =
        Object.defineProperty ||
        function (t, e, r) {
          t[e] = r.value;
        },
      i = 'function' == typeof Symbol ? Symbol : {},
      a = i.iterator || '@@iterator',
      c = i.asyncIterator || '@@asyncIterator',
      u = i.toStringTag || '@@toStringTag';
    function s(t, e, r) {
      return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
    }
    try {
      s({}, '');
    } catch (t) {
      s = function (t, e, r) {
        return (t[e] = r);
      };
    }
    function l(t, e, r, n) {
      var i = e && e.prototype instanceof g ? e : g,
        a = Object.create(i.prototype),
        c = new k(n || []);
      return o(a, '_invoke', { value: P(t, r, c) }), a;
    }
    function f(t, e, r) {
      try {
        return { type: 'normal', arg: t.call(e, r) };
      } catch (t) {
        return { type: 'throw', arg: t };
      }
    }
    e.wrap = l;
    var h = 'suspendedStart',
      p = 'suspendedYield',
      y = 'executing',
      v = 'completed',
      d = {};
    function g() {}
    function m() {}
    function w() {}
    var b = {};
    s(b, a, function () {
      return this;
    });
    var x = Object.getPrototypeOf,
      E = x && x(x(N([])));
    E && E !== r && n.call(E, a) && (b = E);
    var L = (w.prototype = g.prototype = Object.create(b));
    function O(t) {
      ['next', 'throw', 'return'].forEach(function (e) {
        s(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function S(t, e) {
      function r(o, i, a, c) {
        var u = f(t[o], t, i);
        if ('throw' !== u.type) {
          var s = u.arg,
            l = s.value;
          return l && 'object' == ot(l) && n.call(l, '__await')
            ? e.resolve(l.__await).then(
                function (t) {
                  r('next', t, a, c);
                },
                function (t) {
                  r('throw', t, a, c);
                },
              )
            : e.resolve(l).then(
                function (t) {
                  (s.value = t), a(s);
                },
                function (t) {
                  return r('throw', t, a, c);
                },
              );
        }
        c(u.arg);
      }
      var i;
      o(this, '_invoke', {
        value: function (t, n) {
          function o() {
            return new e(function (e, o) {
              r(t, n, e, o);
            });
          }
          return (i = i ? i.then(o, o) : o());
        },
      });
    }
    function P(e, r, n) {
      var o = h;
      return function (i, a) {
        if (o === y) throw new Error('Generator is already running');
        if (o === v) {
          if ('throw' === i) throw a;
          return { value: t, done: !0 };
        }
        for (n.method = i, n.arg = a; ; ) {
          var c = n.delegate;
          if (c) {
            var u = _(c, n);
            if (u) {
              if (u === d) continue;
              return u;
            }
          }
          if ('next' === n.method) n.sent = n._sent = n.arg;
          else if ('throw' === n.method) {
            if (o === h) throw ((o = v), n.arg);
            n.dispatchException(n.arg);
          } else 'return' === n.method && n.abrupt('return', n.arg);
          o = y;
          var s = f(e, r, n);
          if ('normal' === s.type) {
            if (((o = n.done ? v : p), s.arg === d)) continue;
            return { value: s.arg, done: n.done };
          }
          'throw' === s.type && ((o = v), (n.method = 'throw'), (n.arg = s.arg));
        }
      };
    }
    function _(e, r) {
      var n = r.method,
        o = e.iterator[n];
      if (o === t)
        return (
          (r.delegate = null),
          ('throw' === n && e.iterator.return && ((r.method = 'return'), (r.arg = t), _(e, r), 'throw' === r.method)) ||
            ('return' !== n &&
              ((r.method = 'throw'), (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
          d
        );
      var i = f(o, e.iterator, r.arg);
      if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), d;
      var a = i.arg;
      return a
        ? a.done
          ? ((r[e.resultName] = a.value),
            (r.next = e.nextLoc),
            'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
            (r.delegate = null),
            d)
          : a
        : ((r.method = 'throw'), (r.arg = new TypeError('iterator result is not an object')), (r.delegate = null), d);
    }
    function T(t) {
      var e = { tryLoc: t[0] };
      1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
    }
    function j(t) {
      var e = t.completion || {};
      (e.type = 'normal'), delete e.arg, (t.completion = e);
    }
    function k(t) {
      (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(T, this), this.reset(!0);
    }
    function N(e) {
      if (e || '' === e) {
        var r = e[a];
        if (r) return r.call(e);
        if ('function' == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            i = function r() {
              for (; ++o < e.length; ) if (n.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
              return (r.value = t), (r.done = !0), r;
            };
          return (i.next = i);
        }
      }
      throw new TypeError(ot(e) + ' is not iterable');
    }
    return (
      (m.prototype = w),
      o(L, 'constructor', { value: w, configurable: !0 }),
      o(w, 'constructor', { value: m, configurable: !0 }),
      (m.displayName = s(w, u, 'GeneratorFunction')),
      (e.isGeneratorFunction = function (t) {
        var e = 'function' == typeof t && t.constructor;
        return !!e && (e === m || 'GeneratorFunction' === (e.displayName || e.name));
      }),
      (e.mark = function (t) {
        return (
          Object.setPrototypeOf ? Object.setPrototypeOf(t, w) : ((t.__proto__ = w), s(t, u, 'GeneratorFunction')),
          (t.prototype = Object.create(L)),
          t
        );
      }),
      (e.awrap = function (t) {
        return { __await: t };
      }),
      O(S.prototype),
      s(S.prototype, c, function () {
        return this;
      }),
      (e.AsyncIterator = S),
      (e.async = function (t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new S(l(t, r, n, o), i);
        return e.isGeneratorFunction(r)
          ? a
          : a.next().then(function (t) {
              return t.done ? t.value : a.next();
            });
      }),
      O(L),
      s(L, u, 'Generator'),
      s(L, a, function () {
        return this;
      }),
      s(L, 'toString', function () {
        return '[object Generator]';
      }),
      (e.keys = function (t) {
        var e = Object(t),
          r = [];
        for (var n in e) r.push(n);
        return (
          r.reverse(),
          function t() {
            for (; r.length; ) {
              var n = r.pop();
              if (n in e) return (t.value = n), (t.done = !1), t;
            }
            return (t.done = !0), t;
          }
        );
      }),
      (e.values = N),
      (k.prototype = {
        constructor: k,
        reset: function (e) {
          if (
            ((this.prev = 0),
            (this.next = 0),
            (this.sent = this._sent = t),
            (this.done = !1),
            (this.delegate = null),
            (this.method = 'next'),
            (this.arg = t),
            this.tryEntries.forEach(j),
            !e)
          )
            for (var r in this) 't' === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function () {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ('throw' === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function (e) {
          if (this.done) throw e;
          var r = this;
          function o(n, o) {
            return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
              c = a.completion;
            if ('root' === a.tryLoc) return o('end');
            if (a.tryLoc <= this.prev) {
              var u = n.call(a, 'catchLoc'),
                s = n.call(a, 'finallyLoc');
              if (u && s) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!s) throw new Error('try statement without catch or finally');
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];
            if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return (
            (a.type = t), (a.arg = e), i ? ((this.method = 'next'), (this.next = i.finallyLoc), d) : this.complete(a)
          );
        },
        complete: function (t, e) {
          if ('throw' === t.type) throw t.arg;
          return (
            'break' === t.type || 'continue' === t.type
              ? (this.next = t.arg)
              : 'return' === t.type
              ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
              : 'normal' === t.type && e && (this.next = e),
            d
          );
        },
        finish: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), j(r), d;
          }
        },
        catch: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.tryLoc === t) {
              var n = r.completion;
              if ('throw' === n.type) {
                var o = n.arg;
                j(r);
              }
              return o;
            }
          }
          throw new Error('illegal catch attempt');
        },
        delegateYield: function (e, r, n) {
          return (
            (this.delegate = { iterator: N(e), resultName: r, nextLoc: n }), 'next' === this.method && (this.arg = t), d
          );
        },
      }),
      e
    );
  }
  function at(t, e, r) {
    var n;
    return (
      (n = (function (t, e) {
        if ('object' != ot(t) || !t) return t;
        var r = t[Symbol.toPrimitive];
        if (void 0 !== r) {
          var n = r.call(t, 'string');
          if ('object' != ot(n)) return n;
          throw new TypeError('@@toPrimitive must return a primitive value.');
        }
        return String(t);
      })(e)),
      (e = 'symbol' == ot(n) ? n : String(n)) in t
        ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 })
        : (t[e] = r),
      t
    );
  }
  function ct(t, e, r, n, o, i, a) {
    try {
      var c = t[i](a),
        u = c.value;
    } catch (t) {
      return void r(t);
    }
    c.done ? e(u) : Promise.resolve(u).then(n, o);
  }
  function ut(t, e, r) {
    if (!(t.accuracy > 2e3))
      for (var n = tt(t.latitude, t.longitude), o = 0, i = 0; i < e.length; ++i)
        (o = n(e[i].latitude, e[i].longitude)) < 1e3 && r(e[i].id, 1e3),
          o < 5e3 && r(e[i].id, 5e3),
          o < 1e4 && r(e[i].id, 1e4),
          o < 2e4 && r(e[i].id, 2e4);
  }
  function st(t, e, r, n, o) {
    return lt.apply(this, arguments);
  }
  function lt() {
    var t;
    return (
      (t = it().mark(function t(e, r, n, o, i) {
        var a, u, s, l, f, h;
        return it().wrap(function (t) {
          for (;;)
            switch ((t.prev = t.next)) {
              case 0:
                return (
                  (t.next = 2),
                  fetch(c.intersectingIsochronesGetURL(), {
                    method: 'POST',
                    headers: { Authorization: 'Bearer '.concat(process.env.RETAILTUNE_KEY) },
                    body: JSON.stringify({ latitude: e.latitude, longitude: e.longitude }),
                  })
                );
              case 2:
                if ((a = t.sent).ok) {
                  t.next = 5;
                  break;
                }
                throw new Error('Unable to fetch isochrones data for user position. status='.concat(a.status));
              case 5:
                return (t.next = 7), a.json();
              case 7:
                for (u = t.sent, s = new Array(u.length), l = 0; l < u.length; ++l)
                  (s[l] = u[l].store_id), o(s[l], u[l]);
                return (
                  (t.next = 12),
                  fetch(c.productAvailabilityInStoresURL(), {
                    method: 'POST',
                    headers: { Authorization: 'Bearer '.concat(process.env.RETAILTUNE_KEY) },
                    body: JSON.stringify(at(at({}, r, n), 'store_ids', s)),
                  })
                );
              case 12:
                if ((a = t.sent).ok) {
                  t.next = 15;
                  break;
                }
                throw new Error(
                  'Unable to fetch product availabilities for product '
                    .concat(r, '=')
                    .concat(n, '. status=')
                    .concat(a.status),
                );
              case 15:
                return (t.next = 17), a.json();
              case 17:
                for (f = t.sent, h = 0; h < u.length; ++h) f[u[h].store_id] && i(u[h].store_id, u[h]);
              case 19:
              case 'end':
                return t.stop();
            }
        }, t);
      })),
      (lt = function () {
        var e = this,
          r = arguments;
        return new Promise(function (n, o) {
          var i = t.apply(e, r);
          function a(t) {
            ct(i, n, o, a, c, 'next', t);
          }
          function c(t) {
            ct(i, n, o, a, c, 'throw', t);
          }
          a(void 0);
        });
      }),
      lt.apply(this, arguments)
    );
  }
  function ft(t) {
    return (
      (ft =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            }),
      ft(t)
    );
  }
  function ht() {
    ht = function () {
      return e;
    };
    var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o =
        Object.defineProperty ||
        function (t, e, r) {
          t[e] = r.value;
        },
      i = 'function' == typeof Symbol ? Symbol : {},
      a = i.iterator || '@@iterator',
      c = i.asyncIterator || '@@asyncIterator',
      u = i.toStringTag || '@@toStringTag';
    function s(t, e, r) {
      return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
    }
    try {
      s({}, '');
    } catch (t) {
      s = function (t, e, r) {
        return (t[e] = r);
      };
    }
    function l(t, e, r, n) {
      var i = e && e.prototype instanceof g ? e : g,
        a = Object.create(i.prototype),
        c = new k(n || []);
      return o(a, '_invoke', { value: P(t, r, c) }), a;
    }
    function f(t, e, r) {
      try {
        return { type: 'normal', arg: t.call(e, r) };
      } catch (t) {
        return { type: 'throw', arg: t };
      }
    }
    e.wrap = l;
    var h = 'suspendedStart',
      p = 'suspendedYield',
      y = 'executing',
      v = 'completed',
      d = {};
    function g() {}
    function m() {}
    function w() {}
    var b = {};
    s(b, a, function () {
      return this;
    });
    var x = Object.getPrototypeOf,
      E = x && x(x(N([])));
    E && E !== r && n.call(E, a) && (b = E);
    var L = (w.prototype = g.prototype = Object.create(b));
    function O(t) {
      ['next', 'throw', 'return'].forEach(function (e) {
        s(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function S(t, e) {
      function r(o, i, a, c) {
        var u = f(t[o], t, i);
        if ('throw' !== u.type) {
          var s = u.arg,
            l = s.value;
          return l && 'object' == ft(l) && n.call(l, '__await')
            ? e.resolve(l.__await).then(
                function (t) {
                  r('next', t, a, c);
                },
                function (t) {
                  r('throw', t, a, c);
                },
              )
            : e.resolve(l).then(
                function (t) {
                  (s.value = t), a(s);
                },
                function (t) {
                  return r('throw', t, a, c);
                },
              );
        }
        c(u.arg);
      }
      var i;
      o(this, '_invoke', {
        value: function (t, n) {
          function o() {
            return new e(function (e, o) {
              r(t, n, e, o);
            });
          }
          return (i = i ? i.then(o, o) : o());
        },
      });
    }
    function P(e, r, n) {
      var o = h;
      return function (i, a) {
        if (o === y) throw new Error('Generator is already running');
        if (o === v) {
          if ('throw' === i) throw a;
          return { value: t, done: !0 };
        }
        for (n.method = i, n.arg = a; ; ) {
          var c = n.delegate;
          if (c) {
            var u = _(c, n);
            if (u) {
              if (u === d) continue;
              return u;
            }
          }
          if ('next' === n.method) n.sent = n._sent = n.arg;
          else if ('throw' === n.method) {
            if (o === h) throw ((o = v), n.arg);
            n.dispatchException(n.arg);
          } else 'return' === n.method && n.abrupt('return', n.arg);
          o = y;
          var s = f(e, r, n);
          if ('normal' === s.type) {
            if (((o = n.done ? v : p), s.arg === d)) continue;
            return { value: s.arg, done: n.done };
          }
          'throw' === s.type && ((o = v), (n.method = 'throw'), (n.arg = s.arg));
        }
      };
    }
    function _(e, r) {
      var n = r.method,
        o = e.iterator[n];
      if (o === t)
        return (
          (r.delegate = null),
          ('throw' === n && e.iterator.return && ((r.method = 'return'), (r.arg = t), _(e, r), 'throw' === r.method)) ||
            ('return' !== n &&
              ((r.method = 'throw'), (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
          d
        );
      var i = f(o, e.iterator, r.arg);
      if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), d;
      var a = i.arg;
      return a
        ? a.done
          ? ((r[e.resultName] = a.value),
            (r.next = e.nextLoc),
            'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
            (r.delegate = null),
            d)
          : a
        : ((r.method = 'throw'), (r.arg = new TypeError('iterator result is not an object')), (r.delegate = null), d);
    }
    function T(t) {
      var e = { tryLoc: t[0] };
      1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
    }
    function j(t) {
      var e = t.completion || {};
      (e.type = 'normal'), delete e.arg, (t.completion = e);
    }
    function k(t) {
      (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(T, this), this.reset(!0);
    }
    function N(e) {
      if (e || '' === e) {
        var r = e[a];
        if (r) return r.call(e);
        if ('function' == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            i = function r() {
              for (; ++o < e.length; ) if (n.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
              return (r.value = t), (r.done = !0), r;
            };
          return (i.next = i);
        }
      }
      throw new TypeError(ft(e) + ' is not iterable');
    }
    return (
      (m.prototype = w),
      o(L, 'constructor', { value: w, configurable: !0 }),
      o(w, 'constructor', { value: m, configurable: !0 }),
      (m.displayName = s(w, u, 'GeneratorFunction')),
      (e.isGeneratorFunction = function (t) {
        var e = 'function' == typeof t && t.constructor;
        return !!e && (e === m || 'GeneratorFunction' === (e.displayName || e.name));
      }),
      (e.mark = function (t) {
        return (
          Object.setPrototypeOf ? Object.setPrototypeOf(t, w) : ((t.__proto__ = w), s(t, u, 'GeneratorFunction')),
          (t.prototype = Object.create(L)),
          t
        );
      }),
      (e.awrap = function (t) {
        return { __await: t };
      }),
      O(S.prototype),
      s(S.prototype, c, function () {
        return this;
      }),
      (e.AsyncIterator = S),
      (e.async = function (t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new S(l(t, r, n, o), i);
        return e.isGeneratorFunction(r)
          ? a
          : a.next().then(function (t) {
              return t.done ? t.value : a.next();
            });
      }),
      O(L),
      s(L, u, 'Generator'),
      s(L, a, function () {
        return this;
      }),
      s(L, 'toString', function () {
        return '[object Generator]';
      }),
      (e.keys = function (t) {
        var e = Object(t),
          r = [];
        for (var n in e) r.push(n);
        return (
          r.reverse(),
          function t() {
            for (; r.length; ) {
              var n = r.pop();
              if (n in e) return (t.value = n), (t.done = !1), t;
            }
            return (t.done = !0), t;
          }
        );
      }),
      (e.values = N),
      (k.prototype = {
        constructor: k,
        reset: function (e) {
          if (
            ((this.prev = 0),
            (this.next = 0),
            (this.sent = this._sent = t),
            (this.done = !1),
            (this.delegate = null),
            (this.method = 'next'),
            (this.arg = t),
            this.tryEntries.forEach(j),
            !e)
          )
            for (var r in this) 't' === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function () {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ('throw' === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function (e) {
          if (this.done) throw e;
          var r = this;
          function o(n, o) {
            return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
              c = a.completion;
            if ('root' === a.tryLoc) return o('end');
            if (a.tryLoc <= this.prev) {
              var u = n.call(a, 'catchLoc'),
                s = n.call(a, 'finallyLoc');
              if (u && s) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!s) throw new Error('try statement without catch or finally');
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];
            if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return (
            (a.type = t), (a.arg = e), i ? ((this.method = 'next'), (this.next = i.finallyLoc), d) : this.complete(a)
          );
        },
        complete: function (t, e) {
          if ('throw' === t.type) throw t.arg;
          return (
            'break' === t.type || 'continue' === t.type
              ? (this.next = t.arg)
              : 'return' === t.type
              ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
              : 'normal' === t.type && e && (this.next = e),
            d
          );
        },
        finish: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), j(r), d;
          }
        },
        catch: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.tryLoc === t) {
              var n = r.completion;
              if ('throw' === n.type) {
                var o = n.arg;
                j(r);
              }
              return o;
            }
          }
          throw new Error('illegal catch attempt');
        },
        delegateYield: function (e, r, n) {
          return (
            (this.delegate = { iterator: N(e), resultName: r, nextLoc: n }), 'next' === this.method && (this.arg = t), d
          );
        },
      }),
      e
    );
  }
  function pt(t, e, r) {
    var n;
    return (
      (n = (function (t, e) {
        if ('object' != ft(t) || !t) return t;
        var r = t[Symbol.toPrimitive];
        if (void 0 !== r) {
          var n = r.call(t, 'string');
          if ('object' != ft(n)) return n;
          throw new TypeError('@@toPrimitive must return a primitive value.');
        }
        return String(t);
      })(e)),
      (e = 'symbol' == ft(n) ? n : String(n)) in t
        ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 })
        : (t[e] = r),
      t
    );
  }
  function yt(t, e, r, n, o, i, a) {
    try {
      var c = t[i](a),
        u = c.value;
    } catch (t) {
      return void r(t);
    }
    c.done ? e(u) : Promise.resolve(u).then(n, o);
  }
  function vt(t) {
    return function () {
      var e = this,
        r = arguments;
      return new Promise(function (n, o) {
        var i = t.apply(e, r);
        function a(t) {
          yt(i, n, o, a, c, 'next', t);
        }
        function c(t) {
          yt(i, n, o, a, c, 'throw', t);
        }
        a(void 0);
      });
    };
  }
  var dt = (function () {
    var t = vt(
      ht().mark(function t(e, r, n) {
        var o, i, a, c, u;
        return ht().wrap(function (t) {
          for (;;)
            switch ((t.prev = t.next)) {
              case 0:
                return (
                  (o =
                    'sku' === e
                      ? 'https://endpoint.retailtune.com/endpoint/v1/product-sku-availabilities/getall'
                      : 'https://endpoint.retailtune.com/endpoint/v1/product-sku-model-availabilities/'),
                  (i = { key: process.env.RETAILTUNE_KEY, query: pt({}, e, r) }),
                  (t.next = 4),
                  fetch(o, { method: 'POST', body: JSON.stringify(i) })
                );
              case 4:
                if ((a = t.sent).ok) {
                  t.next = 7;
                  break;
                }
                throw new Error('Cannot fetch product availabilities: status '.concat(a.status));
              case 7:
                return (t.next = 9), a.json();
              case 9:
                if ('ok' === (c = t.sent).result) {
                  t.next = 12;
                  break;
                }
                throw new Error('Cannot fetch product availabilities: '.concat(c.result));
              case 12:
                for (u = 0; u < c.response.length; ++u) n.set(c.response[u].store_id, c.response[u].availability > 0);
              case 13:
              case 'end':
                return t.stop();
            }
        }, t);
      }),
    );
    return function (e, r, n) {
      return t.apply(this, arguments);
    };
  })();
  function gt(t) {
    return mt.apply(this, arguments);
  }
  function mt() {
    return (mt = vt(
      ht().mark(function t(e) {
        return ht().wrap(
          function (t) {
            for (;;)
              switch ((t.prev = t.next)) {
                case 0:
                  return (e.positionConsent = !0), (t.prev = 1), (t.next = 4), $(process.env.RETAILTUNE_KEY);
                case 4:
                  (e.defaultPosition = t.sent), (t.next = 11);
                  break;
                case 7:
                  (t.prev = 7),
                    (t.t0 = t.catch(1)),
                    console.warn('An error occurred while fetching the default position: fallback position used'),
                    (e.defaultPosition = J);
                case 11:
                  return (t.prev = 11), (t.next = 14), V(e.defaultPosition);
                case 14:
                  (e.userPosition = t.sent), (t.next = 21);
                  break;
                case 17:
                  (t.prev = 17),
                    (t.t1 = t.catch(11)),
                    console.warn('An error occurred while fetching the user position: default position used'),
                    (e.userPosition = e.defaultPosition);
                case 21:
                  e.cachedPositionConsent ||
                    (g(b, { expiration: N(1, 'years'), value: JSON.stringify(!0) }), (e.cachedPositionConsent = !0)),
                    e.cachedDefaultPosition ||
                      (g(x, { expiration: N(1, 'hours'), value: JSON.stringify(e.defaultPosition) }),
                      (e.cachedDefaultPosition = e.defaultPosition)),
                    e.cachedUserPosition ||
                      (g(E, { expiration: N(15, 'minutes'), value: JSON.stringify(e.userPosition) }),
                      (e.cachedUserPosition = e.userPosition));
                case 24:
                case 'end':
                  return t.stop();
              }
          },
          t,
          null,
          [
            [1, 7],
            [11, 17],
          ],
        );
      }),
    )).apply(this, arguments);
  }
  function wt(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
    return n;
  }
  function bt(t) {
    return t.hasOwnProperty('priority');
  }
  function xt(t) {
    return t.hasOwnProperty('typePriority');
  }
  function Et(t, e) {
    return t.distance && e.distance ? (t.distance < e.distance ? -1 : t.distance > e.distance ? 1 : 0) : 0;
  }
  function Lt(t, e) {
    if (bt(t) && bt(e)) return t.priority > e.priority ? 1 : t.priority < e.priority ? -1 : Et(t, e);
    if (xt(t) && xt(e)) return t.typePriority > e.typePriority ? 1 : t.typePriority < e.typePriority ? -1 : Et(t, e);
    throw new Error('sortStoresByPriority: A and B types must be the same');
  }
  var Ot = function (t) {
    var e, r;
    t < 1e3 ? ((e = 'm'), (r = t)) : ((e = 'Km'), (r = t / 1e3));
    var n,
      o,
      i =
        ((n = ''.concat(r).split('.')),
        (o = 2),
        (function (t) {
          if (Array.isArray(t)) return t;
        })(n) ||
          (function (t, e) {
            var r = null == t ? null : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
            if (null != r) {
              var n,
                o,
                i,
                a,
                c = [],
                u = !0,
                s = !1;
              try {
                if (((i = (r = r.call(t)).next), 0 === e)) {
                  if (Object(r) !== r) return;
                  u = !1;
                } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== e); u = !0);
              } catch (t) {
                (s = !0), (o = t);
              } finally {
                try {
                  if (!u && null != r.return && ((a = r.return()), Object(a) !== a)) return;
                } finally {
                  if (s) throw o;
                }
              }
              return c;
            }
          })(n, o) ||
          (function (t, e) {
            if (t) {
              if ('string' == typeof t) return wt(t, e);
              var r = Object.prototype.toString.call(t).slice(8, -1);
              return (
                'Object' === r && t.constructor && (r = t.constructor.name),
                'Map' === r || 'Set' === r
                  ? Array.from(t)
                  : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                  ? wt(t, e)
                  : void 0
              );
            }
          })(n, o) ||
          (function () {
            throw new TypeError(
              'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
            );
          })()),
      a = i[0],
      c = i[1];
    if (0 === c.length) return ''.concat(a, ' ').concat(e);
    var u = c[0],
      s = c.length > 1 ? c[1] : 0;
    return ''.concat(a, '.').concat(u).concat(s, ' ').concat(e);
  };
  function St(t, e, r) {
    for (
      var n,
        o = 1e3 * (r = null !== (n = r) && void 0 !== n ? n : 100),
        i = tt(t.latitude, t.longitude),
        a = null,
        c = 0;
      c < e.length;
      ++c
    )
      (e[c].distance = i(e[c].latitude, e[c].longitude)),
        e[c].distance > o || ((!a || a.distance > e[c].distance) && (a = e[c]));
    return a;
  }
  var Pt = function (t) {
    var e = t.getBoundingClientRect();
    return (
      e.top >= 0 &&
      e.left >= 0 &&
      e.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      e.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  function _t(t, e) {
    return (
      (function (t) {
        if (Array.isArray(t)) return t;
      })(t) ||
      (function (t, e) {
        var r = null == t ? null : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
        if (null != r) {
          var n,
            o,
            i,
            a,
            c = [],
            u = !0,
            s = !1;
          try {
            if (((i = (r = r.call(t)).next), 0 === e)) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== e); u = !0);
          } catch (t) {
            (s = !0), (o = t);
          } finally {
            try {
              if (!u && null != r.return && ((a = r.return()), Object(a) !== a)) return;
            } finally {
              if (s) throw o;
            }
          }
          return c;
        }
      })(t, e) ||
      (function (t, e) {
        if (t) {
          if ('string' == typeof t) return Tt(t, e);
          var r = Object.prototype.toString.call(t).slice(8, -1);
          return (
            'Object' === r && t.constructor && (r = t.constructor.name),
            'Map' === r || 'Set' === r
              ? Array.from(t)
              : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
              ? Tt(t, e)
              : void 0
          );
        }
      })(t, e) ||
      (function () {
        throw new TypeError(
          'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
        );
      })()
    );
  }
  function Tt(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
    return n;
  }
  function jt(t, e, r, n, o) {
    try {
      var i = t,
        a = 1e3 * e.hourOffset,
        c = new Date(i + a).getDay(),
        u = e.openingHours[0 === c ? 6 : c - 1];
      return u && '' !== u.trim()
        ? 'x' === u || 'X' === u
          ? o
            ? "<span class='rt-dayname'>"
                .concat(r, ":</span> <span class='rt-opening-time rt-opening-time--closed'>")
                .concat(n, '</span>')
            : ''.concat(r, ': ').concat(n)
          : o
          ? "<span class='rt-dayname'>".concat(r, ":</span> <time class='rt-opening-time'>").concat(u, '</time>')
          : ''.concat(r, ': ').concat(u)
        : '';
    } catch (t) {
      return U('error', 'string' == typeof t ? t : t instanceof Error ? t.message : JSON.stringify(t)), '';
    }
  }
  function kt(t) {
    var e = t.serverTime,
      r = t.store,
      n = t.format,
      o = t.hoursSeparator,
      i = void 0 === o ? '-' : o,
      a = t.openingsSeparator,
      c = void 0 === a ? ',' : a;
    try {
      var u = e,
        s = 1e3 * r.hourOffset,
        l = new Date(u + s).getDay(),
        f = r.openingHours[0 === l ? 6 : l - 1];
      if (!f || '' === f.trim()) return { status: 'unknown', isClosed: !1, text: '' };
      if ('x' === f || 'X' === f) return { status: 'ok', isClosed: !0, text: '' };
      var h = _t(f.split(','), 2),
        p = h[0],
        y = h[1],
        v = _t('12h' === n ? p.split('-').map(G) : p.split('-'), 2),
        d = v[0],
        g = v[1];
      if (((f = ''.concat(d, ' ').concat(i, ' ').concat(g)), y)) {
        var m = _t('12h' === n ? y.split('-').map(G) : y.split('-'), 2);
        (d = m[0]), (g = m[1]), (f += ' '.concat(c, ' ').concat(d, ' ').concat(i, ' ').concat(g));
      }
      return { status: 'ok', isClosed: !1, text: f };
    } catch (t) {
      return { status: 'error', isClosed: !1, text: '' };
    }
  }
  (exports.CURRENT_POSITION = e.CURRENT_POSITION),
    (exports.DEFAULT_POSITION = e.DEFAULT_POSITION),
    (exports.DEPRECATED__createStoreOpeningTimeText = e.DEPRECATED__createStoreOpeningTimeText),
    (exports.DEPRECATED__getStoreOpeningTime = e.DEPRECATED__getStoreOpeningTime),
    (exports.USER_POSITION = e.USER_POSITION),
    (exports.USER_POSITION_CONSENT = e.USER_POSITION_CONSENT),
    (exports.USER_STORAGE_CONSENT = e.USER_STORAGE_CONSENT),
    (exports._defaultPosition = e._defaultPosition),
    (exports.api = e.api),
    (exports.createAutocompleteHandler = e.createAutocompleteHandler),
    (exports.createDebounceFn = e.createDebounceFn),
    (exports.createExpirationValue = e.createExpirationValue),
    (exports.createPosition = e.createPosition),
    (exports.createThrottleFn = e.createThrottleFn),
    (exports.delay = e.delay),
    (exports.fetchProductAvailabilities = e.fetchProductAvailabilities),
    (exports.fetchUserDefaultPosition = e.fetchUserDefaultPosition),
    (exports.fetchUserPosition = e.fetchUserPosition),
    (exports.findNearestStore = e.findNearestStore),
    (exports.from12to24Hours = e.from12to24Hours),
    (exports.from24to12Hours = e.from24to12Hours),
    (exports.getDevice = e.getDevice),
    (exports.getDistanceText = e.getDistanceText),
    (exports.getExpirable = e.getExpirable),
    (exports.getRadialDistanceFn = e.getRadialDistanceFn),
    (exports.getStoreOpeningTime = e.getStoreOpeningTime),
    (exports.isInViewport = e.isInViewport),
    (exports.isPositionInBounds = e.isPositionInBounds),
    (exports.positionToLatLngLiteral = e.positionToLatLngLiteral),
    (exports.positionToLatLngPair = e.positionToLatLngPair),
    (exports.report = e.report),
    (exports.retailTuneAutocompleteHandler = e.retailTuneAutocompleteHandler),
    (exports.sendIsochronePolygonalEvents = e.sendIsochronePolygonalEvents),
    (exports.sendProximityEvents = e.sendProximityEvents),
    (exports.setExpirable = e.setExpirable),
    (exports.sortStoresByDistance = e.sortStoresByDistance),
    (exports.sortStoresByPriority = e.sortStoresByPriority),
    (exports.updateWidgetState = e.updateWidgetState),
    Object.defineProperty(exports, '__esModule', { value: !0 });
})();
//# sourceMappingURL=index.js.map
